import assets from "../assets";
import { COOKIE_ACCESS_SUBSCRIPTION_STATUS } from "./storage-constants";
import {
  ROUTE_CHAT,
  ROUTE_QUIZ,
  ROUTE_DESCRIPTIVE,
  ROUTE_DASHBOARD,
  ROUTE_SCHOOL_MANAGEMENT,
  ROUTE_STUDENT_MANAGEMENT,
  ROUTE_TEACHER_MANAGEMENT,
  ROUTE_ASPIRANT_MANAGEMENT,
  ROUTE_AI_GENERATE,
  ROUTE_LEARNING_ASSETS,
  ROUTE_COMPETITIVE_EXAM,
  ROUTE_ADMIN_COMPETITIVE_EXAM,
  ROUTE_ADMIN_QUIZ,
} from "../route";
import {
  ROUTE_CHAT as TNPSC_ROUTE_CHAT,
  ROUTE_QUIZ as TNPSC_ROUTE_QUIZ,
  ROUTE_DASHBOARD as TNPSC_ROUTE_DASHBOARD,
  ROUTE_AI_GENERATE as TNPSC_ROUTE_AI_GENERATE,
  ROUTE_LEARNING_ASSETS as TNPSC_ROUTE_LEARNING_ASSETS,
  ROUTE_COMPETITIVE_EXAM as TNPSC_ROUTE_COMPETITIVE_EXAM,
  ROUTE_MOCK_TEST,
  ROUTE_INTERVIEW,
  ROUTE_DESCRIPTIVE as UPSC_ROUTE_DESCRIPTIVE_TEST,
} from "../route/studentRoute";
import {
  ROUTE_CHAT as NEET_ROUTE_CHAT,
  ROUTE_QUIZ as NEET_ROUTE_QUIZ,
  ROUTE_DASHBOARD as NEET_ROUTE_DASHBOARD,
  ROUTE_AI_GENERATE as NEET_ROUTE_AI_GENERATE,
  ROUTE_LEARNING_ASSETS as NEET_ROUTE_LEARNING_ASSETS,
  ROUTE_COMPETITIVE_EXAM as NEET_ROUTE_COMPETITIVE_EXAM,
  ROUTE_MOCK_TEST as NEET_ROUTE_MOCK_TEST,
} from "../route/neetJteRoute";

import {
  ROUTE_CHAT as TN_ROUTE_CHAT,
  ROUTE_QUIZ as TN_ROUTE_QUIZ,
  ROUTE_DASHBOARD as TN_ROUTE_DASHBOARD,
  ROUTE_AI_GENERATE as TN_ROUTE_AI_GENERATE,
  ROUTE_LEARNING_ASSETS as TN_ROUTE_LEARNING_ASSETS,
  ROUTE_COMPETITIVE_EXAM as TN_ROUTE_COMPETITIVE_EXAM,
  ROUTE_MOCK_TEST as TN_ROUTE_MOCK_TEST,
} from "../route/tnpscRoute";
import {
  ROUTE_CHAT as Banking_ROUTE_CHAT,
  ROUTE_QUIZ as Banking_ROUTE_QUIZ,
  ROUTE_DASHBOARD as Banking_ROUTE_DASHBOARD,
  ROUTE_AI_GENERATE as Banking_ROUTE_AI_GENERATE,
  ROUTE_LEARNING_ASSETS as Banking_ROUTE_LEARNING_ASSETS,
  ROUTE_COMPETITIVE_EXAM as Banking_ROUTE_COMPETITIVE_EXAM,
  ROUTE_MOCK_TEST as Banking_ROUTE_MOCK_TEST,
} from "../route/bankingRoute";
import {
  ROUTE_DASHBOARD as COMMUNICATIVE_DASHBOARD,
  ROUTE_CONVERSATION,
  ROUTE_GRAMMAR,
  ROUTE_READING,
  ROUTE_SPOKEN,
  ROUTE_VOCABULARY,
  ROUTE_WRITING,
  ROUTE_EXAMS,
} from "../route/communicative";
import {
  ROUTE_STUDENT_LEADERBOARD,
  ROUTE_STUDENT_PERFORMANCE,
  ROUTE_DASHBOARD as TEACHER_DASHBOARD,
  ROUTE_TEST_CREATION,
  ROUTE_TEST_MANAGEMENT,
  ROUTE_TEACHER_QUIZ,
  ROUTE_QUESTION_PAPERS,
  ROUTE_QUESTION_BANK,
  ROUTE_QUESTION_BANK_VIEW,
  ROUTE_KNOWLEDGE_BASE,
} from "../route/teacherRoute";
import {
  hasAnyActiveSubscription,
  hasCourseAccess,
} from "../hooks/common/courses";

export const WELCOME_CARD = [
  {
    title: "Interactive Learning",
    description:
      "Engage in dynamic, two-way conversations to master any topic.",
    emoji: "📚",
    accent: "blue",
  },
  {
    title: "Instant Answers",
    description: "Get immediate, accurate explanations to your questions.",
    emoji: "⚡",
    accent: "amber",
  },
  {
    title: "Personalized Help",
    description: "Tailored guidance that adapts to your unique learning style.",
    emoji: "🎯",
    accent: "purple",
  },
];

export const CHAT_CONTENT = [
  {
    title: "Explain reflection",
  },
  {
    title: "Explain laws of reflection",
  },
  {
    title: "Explain laws of refraction",
  },
  {
    title: "Define normal & angle of incidence",
  },
];

export const NAV_ICONS = [
  {
    activeIcon: assets.ic_active_home,
    icon: assets.ic_home,
    route: ROUTE_DASHBOARD,
    label: "Dashboard",
  },
  {
    activeIcon: assets.ic_active_mointer,
    icon: assets.ic_nav_moniter,
    route: ROUTE_CHAT,
    label: "AI Tutor",
  },
  {
    activeIcon: assets.ic_active_files,
    icon: assets.ic_files,
    route: ROUTE_AI_GENERATE,
    label: "Content Studio",
  },
  {
    activeIcon: assets.ic_active_video,
    icon: assets.ic_video,
    route: ROUTE_LEARNING_ASSETS,
    label: "My Library",
  },
  {
    activeIcon: assets.ic_active_burger,
    icon: assets.ic_nav_burger,
    route: ROUTE_QUIZ,
    label: "Objective Test",
  },
  {
    activeIcon: assets.ic_active_descriptive,
    icon: assets.ic_practice,
    route: ROUTE_DESCRIPTIVE,
    label: "Written Practice",
  },
  {
    activeIcon: assets.ic_active_award,
    icon: assets.ic_competitive,
    route: ROUTE_COMPETITIVE_EXAM,
    label: "Competitive Exams",
    smallIcon: true,
  },
  {
    activeIcon: assets.ic_active_award,
    icon: assets.ic_competitive,
    route: COMMUNICATIVE_DASHBOARD,
    label: "Communicative English",
    smallIcon: true,
    requiredCourse: "Communicative English",
  },
];

export const UPSC_NAV_ICONS = [
  {
    activeIcon: assets.ic_active_home,
    icon: assets.ic_home,
    route: TNPSC_ROUTE_DASHBOARD,
    label: "Dashboard",
  },
  {
    activeIcon: assets.ic_active_mointer,
    icon: assets.ic_nav_moniter,
    route: TNPSC_ROUTE_CHAT,
    label: "AI Tutor",
  },
  {
    activeIcon: assets.ic_active_files,
    icon: assets.ic_files,
    route: TNPSC_ROUTE_AI_GENERATE,
    label: "Content Studio",
  },
  {
    activeIcon: assets.ic_active_video,
    icon: assets.ic_video,
    route: TNPSC_ROUTE_LEARNING_ASSETS,
    label: "My Library",
  },
  {
    activeIcon: assets.ic_active_burger,
    icon: assets.ic_nav_burger,
    route: TNPSC_ROUTE_QUIZ,
    label: "Objective Test",
  },
  {
    activeIcon: assets.ic_active_descriptive,
    icon: assets.ic_practice,
    route: ROUTE_MOCK_TEST,
    label: "Practice Test",
  },
  {
    activeIcon: assets.ic_active_descriptive,
    icon: assets.ic_practice,
    route: UPSC_ROUTE_DESCRIPTIVE_TEST,
    label: "Written Practice ",
  },
  {
    activeIcon: assets.ic_active_mointer,
    icon: assets.ic_mic,
    route: ROUTE_INTERVIEW,
    label: "Interview Prep",
    smallIcon: true,
  },
  {
    activeIcon: assets.ic_active_award,
    icon: assets.ic_competitive,
    route: TNPSC_ROUTE_COMPETITIVE_EXAM,
    label: "Competitive Exams",
    smallIcon: true,
  },
  {
    activeIcon: assets.ic_active_award,
    icon: assets.ic_competitive,
    route: COMMUNICATIVE_DASHBOARD,
    label: "Communicative English",
    smallIcon: true,
    requiredCourse: "Communicative English",
  },
];

export const TNPSC_NAV_ICONS = [
  {
    activeIcon: assets.ic_active_home,
    icon: assets.ic_home,
    route: TN_ROUTE_DASHBOARD,
    label: "Dashboard",
  },
  {
    activeIcon: assets.ic_active_mointer,
    icon: assets.ic_nav_moniter,
    route: TN_ROUTE_CHAT,
    label: "AI Tutor",
  },
  {
    activeIcon: assets.ic_active_files,
    icon: assets.ic_files,
    route: TN_ROUTE_AI_GENERATE,
    label: "Content Studio",
  },
  {
    activeIcon: assets.ic_active_video,
    icon: assets.ic_video,
    route: TN_ROUTE_LEARNING_ASSETS,
    label: "My Library",
  },
  {
    activeIcon: assets.ic_active_burger,
    icon: assets.ic_nav_burger,
    route: TN_ROUTE_QUIZ,
    label: "Objective Test",
  },
  {
    activeIcon: assets.ic_active_descriptive,
    icon: assets.ic_practice,
    route: TN_ROUTE_MOCK_TEST,
    label: "Practice Test",
  },
  {
    activeIcon: assets.ic_active_award,
    icon: assets.ic_competitive,
    route: TN_ROUTE_COMPETITIVE_EXAM,
    label: "Competitive Exams",
    smallIcon: true,
  },
  {
    activeIcon: assets.ic_active_award,
    icon: assets.ic_competitive,
    route: COMMUNICATIVE_DASHBOARD,
    label: "Communicative English",
    smallIcon: true,
    requiredCourse: "Communicative English",
  },
];

export const BANKING_NAV_ICONS = [
  {
    activeIcon: assets.ic_active_home,
    icon: assets.ic_home,
    route: Banking_ROUTE_DASHBOARD,
    label: "Dashboard",
  },
  {
    activeIcon: assets.ic_active_mointer,
    icon: assets.ic_nav_moniter,
    route: Banking_ROUTE_CHAT,
    label: "AI Tutor",
  },
  {
    activeIcon: assets.ic_active_files,
    icon: assets.ic_files,
    route: Banking_ROUTE_AI_GENERATE,
    label: "Content Studio",
  },
  {
    activeIcon: assets.ic_active_video,
    icon: assets.ic_video,
    route: Banking_ROUTE_LEARNING_ASSETS,
    label: "My Library",
  },
  {
    activeIcon: assets.ic_active_burger,
    icon: assets.ic_nav_burger,
    route: Banking_ROUTE_QUIZ,
    label: "Objective Test",
  },
  {
    activeIcon: assets.ic_active_descriptive,
    icon: assets.ic_practice,
    route: Banking_ROUTE_MOCK_TEST,
    label: "Practice Test",
  },
  {
    activeIcon: assets.ic_active_award,
    icon: assets.ic_competitive,
    route: Banking_ROUTE_COMPETITIVE_EXAM,
    label: "Competitive Exams",
    smallIcon: true,
  },
  {
    activeIcon: assets.ic_active_award,
    icon: assets.ic_competitive,
    route: COMMUNICATIVE_DASHBOARD,
    label: "Communicative English",
    smallIcon: true,
    requiredCourse: "Communicative English",
  },
];

export const NEET_NAV_ICONS = [
  {
    activeIcon: assets.ic_active_home,
    icon: assets.ic_home,
    route: NEET_ROUTE_DASHBOARD,
    label: "Dashboard",
  },
  {
    activeIcon: assets.ic_active_mointer,
    icon: assets.ic_nav_moniter,
    route: NEET_ROUTE_CHAT,
    label: "AI Tutor",
  },
  {
    activeIcon: assets.ic_active_files,
    icon: assets.ic_files,
    route: NEET_ROUTE_AI_GENERATE,
    label: "Content Studio",
  },
  {
    activeIcon: assets.ic_active_video,
    icon: assets.ic_video,
    route: NEET_ROUTE_LEARNING_ASSETS,
    label: "My Library",
  },
  {
    activeIcon: assets.ic_active_burger,
    icon: assets.ic_nav_burger,
    route: NEET_ROUTE_QUIZ,
    label: "Objective Test",
  },
  {
    activeIcon: assets.ic_active_descriptive,
    icon: assets.ic_practice,
    route: NEET_ROUTE_MOCK_TEST,
    label: "Practice Test",
  },
  {
    activeIcon: assets.ic_active_award,
    icon: assets.ic_competitive,
    route: NEET_ROUTE_COMPETITIVE_EXAM,
    label: "Competitive Exams",
    smallIcon: true,
  },
  {
    activeIcon: assets.ic_active_award,
    icon: assets.ic_competitive,
    route: COMMUNICATIVE_DASHBOARD,
    label: "Communicative English",
    smallIcon: true,
    requiredCourse: "Communicative English",
  },
];

export const ADMIN_NAV_ICONS = [
  {
    activeIcon: assets.ic_active_student_manage,
    icon: assets.ic_student_manage,
    route: ROUTE_STUDENT_MANAGEMENT,
    label: "studentlist",
  },
  {
    activeIcon: assets.ic_active_school_manage,
    icon: assets.ic_school_manage,
    route: ROUTE_SCHOOL_MANAGEMENT,
    label: "schoollist",
  },
  {
    activeIcon: assets.ic_active_school_manage,
    icon: assets.ic_school_manage,
    route: ROUTE_ASPIRANT_MANAGEMENT,
    label: "Aspirant",
  },
  {
    activeIcon: assets.ic_active_school_manage,
    icon: assets.ic_school_manage,
    route: ROUTE_TEACHER_MANAGEMENT,
    label: "Teacher",
  },
  {
    activeIcon: assets.ic_active_award,
    icon: assets.ic_competitive,
    route: ROUTE_ADMIN_COMPETITIVE_EXAM,
    label: "competitiveexams",
  },
  {
    activeIcon: assets.ic_active_burger,
    icon: assets.ic_nav_burger,
    route: ROUTE_ADMIN_QUIZ,
    label: "Quiz",
  },
  {
    activeIcon: null,
    icon: assets.ic_settings,
    route: null,
    label: "settings",
  },
];

export const TEACHER_NAV_ICONS = [
  {
    activeIcon: assets.ic_active_dashboard,
    icon: assets.ic_active_dashboard,
    route: TEACHER_DASHBOARD,
    label: "Dashboard",
  },
  {
    activeIcon: assets.ic_active_performance,
    icon: assets.ic_active_performance,
    route: ROUTE_STUDENT_PERFORMANCE,
    label: "Student Performance",
  },
  {
    activeIcon: assets.ic_frame,
    icon: assets.ic_frame,
    route: ROUTE_TEST_CREATION,
    label: "Test Creation",
  },
  {
    activeIcon: assets.ic_active_question,
    icon: assets.ic_active_question,
    route: ROUTE_QUESTION_PAPERS,
    label: "Question Papers",
  },
  {
    activeIcon: assets.ic_active_question_bank,
    icon: assets.ic_active_question_bank,
    route: ROUTE_QUESTION_BANK_VIEW,
    label: "Question Bank",
  },
  {
    activeIcon: assets.ic_active_test,
    icon: assets.ic_active_test,
    route: ROUTE_TEST_MANAGEMENT,
    routes: [ROUTE_TEST_MANAGEMENT, ROUTE_TEACHER_QUIZ],
    label: "Test Management",
  },
  {
    activeIcon: assets.ic_active_leaderboard,
    icon: assets.ic_active_leaderboard,
    route: ROUTE_STUDENT_LEADERBOARD,
    label: "Leaderboard",
  },
  {
    activeIcon: assets.ic_active_knowledge,
    icon: assets.ic_active_knowledge,
    route: ROUTE_KNOWLEDGE_BASE,
    label: "knowledge base",
  },
];

export const COMMUNICATIVE_NAV_ITEMS = [
  { label: "Dashboard", path: COMMUNICATIVE_DASHBOARD },
  { label: "Conversation", path: ROUTE_CONVERSATION },
  { label: "Writing", path: ROUTE_WRITING },
  { label: "Reading", path: ROUTE_READING },
  { label: "Vocabulary", path: ROUTE_VOCABULARY },
  { label: "Grammar", path: ROUTE_GRAMMAR },
  { label: "Read Aloud", path: ROUTE_SPOKEN },
  { label: "Exams", path: ROUTE_EXAMS },
];

export const SUBJECT_OPTIONS = ["Maths", "Physics", "Chemistry", "Biology"];
export const CHAPTER_OPTIONS = ["Light", "Circles", "Atoms", "Matter"];
export const LANGUAGE_OPTIONS = [
  "English",
  "Bengali",
  "Gujarati",
  "Hindi",
  "Kannada",
  "Malayalam",
  "Marathi",
  "Punjabi",
  "Tamil",
  "Telugu",
  "Urdu",
];

export const LANGUAGE_OPTIONS_CBSE = ["English", "Hindi", "Tamil"];
export const LANGUAGE_TN_STATE_BOARD = ["English", "Tamil"];

export const QUESTION_WEIGHTAGE = ["3 marks", "5 marks"];
export const QUESTION_WEIGHTAGE_CBSE = ["3 marks", "5 marks"];
export const QUESTION_WEIGHTAGE_STATE_BOARD = ["2 marks", "5 marks", "8 marks"];

export const getStudentActivityDetails = (data, assets) => {
  return [
    {
      icon: assets.ic_persons,
      title: "Total Students",
      noOfStundets:
        data?.total_students ||
        data?.total_aspirants ||
        data?.total_teachers ||
        0,
    },
    {
      icon: assets.ic_activity_person,
      title: "Active Today",
      noOfStundets: data?.active_today || 0,
    },
    {
      icon: assets.ic_unactivity_person,
      title: "Inactive Today",
      noOfStundets: data?.inactive_today || 0,
    },
  ];
};

export const STUNDET_ACTIVITY_DETAILS = [
  {
    icon: assets.ic_persons,
    title: "Total Students",
    noOfStundets: "1,248",
  },
  {
    icon: assets.ic_activity_person,
    title: "Active Today",
    noOfStundets: "856",
  },
  {
    icon: assets.ic_unactivity_person,
    title: "Inctive Today",
    noOfStundets: "856",
  },
];

export const ANALISYS = [
  {
    title: "Analyzing Your Selection",
    description: "Processing subjects, chapters, and concepts",
    success: true,
  },
  {
    title: "Generating Content",
    description: "Creating curriculum-aligned material",
    success: true,
  },
  {
    title: "Formatting & Review",
    description: "Ensuring quality and readability",
    success: false,
  },
  {
    title: "Finalizing",
    description: "Preparing your learning material",
    success: false,
  },
];

export const SELECT_BOX_COLORS = ["#4F46E5", "#16A34A", "#DC2626"];

export const COMPETITIVE_EXAM_STATIC_DATA = [
  {
    icon: assets.ic_jee,
    title: "JEE",
    description: "Engineering entrance for IITs & NITs",
    courseName: "Engineering",
    bgColor: "#EFF6FF",
    brColor: "#DBEAFE",
    color: "#1D4ED8",
  },
  {
    icon: assets.ic_neet,
    title: "NEET",
    description: "Medical entrance for MBBS & BDS",
    courseName: "Medical",
    bgColor: "#F0FFF5",
    brColor: "#16A34A",
    color: "#16A34A",
  },
  {
    icon: assets.ic_upse,
    title: "UPSC",
    description: "Civil services exam for IAS, IPS",
    courseName: "Civil Services",
    bgColor: "#F5F3FF",
    brColor: "#6D28D9",
    color: "#6D28D9",
  },
  {
    icon: assets.ic_ssc,
    title: "SSC",
    description: "Staff Selection Commission exams",
    courseName: "Govt Job",
    bgColor: "#FFF5EF",
    brColor: "#EA580C",
    color: "#EA580C",
  },
  {
    icon: assets.ic_bank,
    title: "Banking",
    description: "IBPS, SBI PO & Clerk exams",
    courseName: "Banking",
    bgColor: "#F0FDFA",
    brColor: "#0F766E",
    color: "Banking",
  },
  {
    icon: assets.ic_nda,
    title: "NDA",
    description: "National Defence Academy exam",
    courseName: "Defence",
    bgColor: "#FFEBEB",
    brColor: "#B91C1C",
    color: "#B91C1C",
  },
  {
    icon: assets.ic_cat,
    title: "CAT",
    description: "MBA entrance for IIMs & top B-schools",
    courseName: "MBA",
    bgColor: "#EFF6FF",
    brColor: "#DBEAFE",
    color: "#4338CA",
  },
  {
    icon: assets.ic_clat,
    title: "CLAT",
    description: "Entrance for National Law Universities",
    courseName: "Law",
    bgColor: "#FFFBEB",
    brColor: "#B45309",
    color: "#B45309",
  },
  {
    icon: assets.ic_gate,
    title: "GATE",
    description: "Graduate Aptitude Test in Engineering",
    courseName: "Engineering",
    bgColor: "#EFF6FF",
    brColor: "#DBEAFE",
    color: "#0E7490",
  },
  {
    icon: assets.ic_cuet,
    title: "CUET",
    description: "Common University Entrance Test",
    courseName: "University",
    bgColor: "#FDF2F8",
    brColor: "#BE185D",
    color: "#BE185D",
  },
  {
    icon: assets.ic_railway,
    title: "Railway",
    description: "Railway Recruitment Board exams",
    courseName: "Govt Job",
    bgColor: "#FFF5EF",
    brColor: "#EA580C",
    color: "#EA580C",
  },
  {
    icon: assets.ic_psc,
    title: "TNPSC",
    description: "State Public Service Commission exams",
    courseName: "Civil Services",
    bgColor: "#F5F3FF",
    brColor: "#6D28D9",
    color: "#6D28D9",
  },
  {
    icon: assets.ic_tnstate_board,
    title: "TN_STATE_BOARD",
    description:
      "Tamil Nadu curriculum focused on strong foundational learning.",
    courseName: "Schools",
    bgColor: "#F5F3FF",
    brColor: "#6D28D9",
    color: "#6D28D9",
  },
  {
    icon: assets.ic_icse,
    title: "ICSE",
    description:
      "Concept-based curriculum with strong language and analytical focus.",
    courseName: "Schools",
    bgColor: "#F5F3FF",
    brColor: "#6D28D9",
    color: "#6D28D9",
  },
  {
    icon: assets.ic_caie,
    title: "CAIE",
    description:
      "International curriculum emphasizing global and conceptual education",
    courseName: "Schools",
    bgColor: "#F5F3FF",
    brColor: "#6D28D9",
    color: "#6D28D9",
  },
  {
    icon: assets.ic_cbse,
    title: "CBSE",
    description:
      "National curriculum for academic and competitive exam success.",
    courseName: "Schools",
    bgColor: "#F5F3FF",
    brColor: "#6D28D9",
    color: "#6D28D9",
  },
  {
    icon: assets.ic_cbse,
    title: "Communicative English",
    description:
      "National curriculum for academic and competitive exam success.",
    courseName: "Schools",
    bgColor: "#F5F3FF",
    brColor: "#6D28D9",
    color: "#6D28D9",
  },
];

export const CATEGORY_LIST = [
  { id: 1, label: "All Categories" },
  { id: 2, label: "Engineering Exams" },
  { id: 3, label: "Medical Exams" },
  { id: 4, label: "Government Exams" },
  { id: 5, label: "School Exams" },
];

export const SKILL_META = {
  conversation: {
    label: "Conversation",
    icon: assets.ic_conversation,
    color: "blue",
  },
  writing: { label: "Writing", icon: assets.ic_writing, color: "purple" },
  reading: { label: "Reading", icon: assets.ic_reading, color: "teal" },
  readAloud: { label: "Read Aloud", icon: assets.ic_read, color: "orange" },
  vocabulary: { label: "Vocabulary", icon: assets.ic_text, color: "yellow" },
  grammar: { label: "Grammar", icon: assets.ic_grammar, color: "red" },
};

// export const updateNavItemsBySubscription = (
//   navItems,
//   subscribedCourses = [],
// ) => {
//   const subscriptionStatus = localStorage.getItem(
//     COOKIE_ACCESS_SUBSCRIPTION_STATUS,
//   );
//   const isInactive = subscriptionStatus === "inactive";

//   const isCommunicativeEnglishSubscribed = subscribedCourses.some(
//     (c) => c.course === "Communicative English",
//   );

//   return navItems
//     .filter((item) => {
//       if (item.requiredCourse === "Communicative English") {
//         return isCommunicativeEnglishSubscribed;
//       }
//       return true;
//     })
//     .map((item) => ({
//       ...item,
//       disabled: isInactive ? item.label !== "Competitive Exams" : false,
//     }));
// };

// export const updateNavItemsBySubscription = (
//   navItems,
//   subscribedCourses = [],
// ) => {
//   const hasActiveSubscription = hasAnyActiveSubscription(subscribedCourses);

//   return navItems.map((item) => ({
//     ...item,
//     disabled: !hasActiveSubscription && item.label !== "Competitive Exams",
//   }));
// };

export const updateNavItemsBySubscription = (
  navItems,
  subscribedCourses = [],
  currentCourse,
  role,
) => {
  // Guest users
  // if (role === "guest") {
  //   return navItems.filter((item) => item.label !== "Communicative English");
  // }

  // Check Communicative English access
  const hasCommunicativeEnglish = hasCourseAccess(
    subscribedCourses,
    "Communicative English",
  );

  // Guest users
  if (role === "guest") {
    return navItems
      .filter((item) => {
        // Hide only if user doesn't have Communicative English
        if (
          item.label === "Communicative English" &&
          !hasCommunicativeEnglish
        ) {
          return false;
        }

        return true;
      })
      .map((item) => ({
        ...item,
        disabled: false,
      }));
  }

  const hasAccess = hasCourseAccess(subscribedCourses, currentCourse);

  return navItems.map((item) => {
    if (item.label === "Competitive Exams") {
      return {
        ...item,
        disabled: false,
      };
    }

    if (item.requiredCourse) {
      return {
        ...item,
        disabled: !hasCourseAccess(subscribedCourses, item.requiredCourse),
      };
    }

    return {
      ...item,
      disabled: !hasAccess,
    };
  });
};
